module.exports = __webpack_public_path__ + "img/Header3.b1a770fd.jpg";